import { reject, find } from 'lodash';

const isMobileDevice = () =>
  typeof window.orientation !== 'undefined' ||
  navigator.userAgent.indexOf('IEMobile') !== -1;

const gateKeep = (destinations, passwordNeedsChanging, permissions) => {
  console.table(destinations);
  console.table(permissions);

  const dests = reject(destinations, { name: 'Gatekeeper' });
  const communityDestination = find(dests, { permission: 'hasAppCommunity' });
  const cordataWebDestination = find(dests, { permission: 'hasAppCordataWeb' });
  const navigatorDestination = find(dests, { permission: 'hasAppNavigator' });
  const researchDestination = find(dests, { permission: 'hasAppResearch' });

  const hwcPermission = find(permissions, { securityPermissionName: 'hasHWC' });
  const cordataWebPermission = find(permissions, { securityPermissionName: 'hasAppCordataWeb' });
  const sponsorPermission = find(permissions, { securityPermissionName: 'hasAppSponsor' });
  const communityPermission = find(permissions, { securityPermissionName: 'hasAppCommunity' });
  const identityPermission = find(permissions, { securityPermissionName: 'hasAppIdentity' });
  const citPermission = find(permissions, { securityPermissionName: 'hasAppCit' });

  if (passwordNeedsChanging) {
    window.location = '/user/change-password';
  } else if (cordataWebPermission && cordataWebDestination) {
    window.location = `${cordataWebDestination.url}/home`;
  } else if (
    communityDestination && (
      (isMobileDevice() && communityPermission) ||
      hwcPermission ||
      sponsorPermission ||
      citPermission ||
      identityPermission
    )
  ) {
    window.location = `${communityDestination.url}/home`;
  } else if (researchDestination) {
    window.location = `${researchDestination.url}/r`;
  } else if (navigatorDestination) {
    window.location = `${navigatorDestination.url}/home`;
  } else if (dests.length === 1) {
    window.location = dests[0].url;
  }
};

export default gateKeep;
